import React from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";

const DEFAULT_PLACEHOLDER_STRING = "Select...";

class Dropdown extends React.Component {
  static defaultProps = { baseClassName: "dropdown" };

  constructor(props) {
    super(props);
    this.state = {
      selected: this.parseValue(props.value, props.options) || {
        label: typeof props.placeholder === "undefined" ? DEFAULT_PLACEHOLDER_STRING : props.placeholder,
        value: ""
      },
      isOpen: false
    };
    this.mounted = true;
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.fireChangeEvent = this.fireChangeEvent.bind(this);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.value) {
      const selected = this.parseValue(newProps.value, newProps.options);
      if (selected !== this.state.selected) {
        this.setState({ selected: selected });
      }
    } else {
      this.setState({
        selected: {
          label: typeof newProps.placeholder === "undefined" ? DEFAULT_PLACEHOLDER_STRING : newProps.placeholder,
          value: ""
        }
      });
    }
  }

  componentDidMount() {
    document.addEventListener("click", this.handleDocumentClick, false);
    document.addEventListener("touchend", this.handleDocumentClick, false);
  }

  componentWillUnmount() {
    this.mounted = false;
    document.removeEventListener("click", this.handleDocumentClick, false);
    document.removeEventListener("touchend", this.handleDocumentClick, false);
  }

  handleMouseDown(event) {
    if (this.props.onFocus && typeof this.props.onFocus === "function") {
      this.props.onFocus(this.state.isOpen);
    }
    if (event.type === "mousedown" && event.button !== 0) return;
    event.stopPropagation();
    event.preventDefault();

    if (!this.props.disabled) {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }

  parseValue(value, options) {
    let option;

    if (typeof value === "string") {
      for (let i = 0, num = options.length; i < num; i++) {
        if (options[ i ].type === "group") {
          const match = options[ i ].items.filter(item => item.value === value);
          if (match.length) {
            option = match[ 0 ];
          }
        } else if (typeof options[ i ].value !== "undefined" && options[ i ].value === value) {
          option = options[ i ];
        }
      }
    }

    return option || value;
  }

  setValue(value, label) {
    let newState = {
      selected: {
        value,
        label
      },
      isOpen: false
    };
    this.fireChangeEvent(newState);
    this.setState(newState);
  }

  fireChangeEvent(newState) {
    if (newState.selected !== this.state.selected && this.props.onChange) {
      this.props.onChange(newState.selected);
    }
  }

  renderOption(option, bindEvents = true) {
    let value = option.value;
    if (typeof value === "undefined") {
      value = option.label || option;
    }
    let label = option.label || option.value || option;

    const classes = {
      [ `${this.props.baseClassName}__option` ]: true,
      [ option.className ]: !!option.className,
      "selected": value === this.state.selected.value || value === this.state.selected
    };

    const optionClass = classNames(classes);

    return (
      <div
        key={ value }
        className={ optionClass }
        onMouseDown={ bindEvents ? this.setValue.bind(this, value, label) : null }
        onClick={ bindEvents ? this.setValue.bind(this, value, label)  : null}>
        { label }
      </div>
    );
  }

  buildMenu(bindEvents = true) {
    let { options, baseClassName } = this.props;
    let ops = options.map((option) => {
      if (option.type === "group") {
        let groupTitle = (<div className={ `${baseClassName}__title` }>
          { option.name }
        </div>);
        let _options = option.items.map((item) => this.renderOption(item, bindEvents));

        return (
          <div className={ `${baseClassName}__group` } key={ option.name }>
            { groupTitle }
            { _options }
          </div>
        );
      } else {
        return this.renderOption(option, bindEvents);
      }
    });

    return ops.length ? ops : <div className={ `${baseClassName}__noresults` }>
      No options found
    </div>;
  }

  handleDocumentClick(event) {
    if (this.mounted) {
      if (!ReactDOM.findDOMNode(this).contains(event.target)) {
        if (this.state.isOpen) {
          this.setState({ isOpen: false });
        }
      }
    }
  }

  isValueSelected() {
    return typeof this.state.selected === "string" || this.state.selected.value !== "";
  }

  render() {
    const { baseClassName, controlClassName, placeholderClassName, menuClassName, arrowClassName, arrowClosed, arrowOpen, className } = this.props;

    const disabledClass = this.props.disabled ? "disabled" : "";
    const placeHolderValue = typeof this.state.selected === "string" ? this.state.selected : this.state.selected.label;

    const dropdownClass = classNames({
      [ `${baseClassName}__root` ]: true,
      [ className ]: !!className,
      "open": this.state.isOpen
    });
    const controlClass = classNames({
      [ `${baseClassName}__control` ]: true,
      [ controlClassName ]: !!controlClassName,
      [ disabledClass ]: !!disabledClass
    });
    const placeholderClass = classNames({
      [ `${baseClassName}__placeholder` ]: true,
      [ placeholderClassName ]: !!placeholderClassName,
      "selected": this.isValueSelected()
    });
    const menuClass = classNames({
      [ `${baseClassName}__menu` ]: true,
      [ menuClassName ]: !!menuClassName
    });
    const arrowClass = classNames({
      [ `${baseClassName}__arrow` ]: true,
      [ arrowClassName ]: !!arrowClassName
    });

    const value = (<div className={ placeholderClass }>
      { placeHolderValue }
    </div>);
    const menu = <div className={ menuClass }>
      { this.buildMenu() }
    </div>;
    const cloneMenu = <div className={ menuClass + " width-clone" }>
      { this.buildMenu(false) }
    </div>;

    return (
      <div className={ dropdownClass }>
        <div className={ controlClass } onMouseDown={ this.handleMouseDown.bind(this) }
             onTouchEnd={ this.handleMouseDown.bind(this) }>
          { value }
          <div className={ `${baseClassName}__arrow-wrapper` }>
            { arrowOpen && arrowClosed
              ? this.state.isOpen ? arrowOpen : arrowClosed
              : <span className={ arrowClass }/> }
          </div>
        </div>
        { cloneMenu }
        { menu }
      </div>
    );
  }
}

export default Dropdown;


// WEBPACK FOOTER //
// ./app/components/Dropdown/Dropdown.jsx